import { Node, Edge } from "reactflow";
import { ButtonsNodeData } from "./buttonsNode";
import { ITopicPair } from "src/app/nlp/~store/models/TopicPair";

export enum Layout {
    Horizontal = "horizontal",
    Vertical = "vertical",
}

export enum GraphDirection {
    Horizontal = "LR",
    Vertical = "TB",
}

export enum NodeType {
    TopicPair = "topicPair",
}

export enum EdgeType {
    Custom = "custom",
}

export interface GraphData {
    nodes: Node<ButtonsNodeData>[];
    edges: Edge[];
}

export interface TopicPairsTree {
    id: string;
    pair: ITopicPair;
    children: TopicPairsTree[];
}

export enum TopicPairParameterJsonKey {
    DefaultNextTrigger = "DefaultNextTrigger",
    TextTrigger = "TextTrigger",
    FileTrigger = "FileTrigger",
    GeoTrigger = "GeoTrigger",
    NextTriggerType = "TopicPairParameterJsonNextTriggerTypeKey",
}
